import React, { useState, useEffect, useContext } from "react";
import { OnOffWidget, WidgetRadio, WidgetScroll } from "./";
import { LeftSection } from "../../context/LeftSectionContext";

const Widgets = ({ zone, sendWidgetCommand, health, showAll }) => {
  const [isPhone, setIsPhone] = useState(false);
  const { show } = useContext(LeftSection);
  const [showFreezing, setShowFreezing] = useState(false);

  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 576) {
      setIsPhone(true);
    }
  }, []);

  return (
    <>
      <div className="col-lg-4 col-xl-3 col-md-4 col-6 mb-3 px-3 ">
        {(zone.property[0] === "Widget1" ||
          zone.property[0] === "Widget3" ||
          zone.property[0] === "Widget2" ||
          zone.property[0] === "Widget6" ||
          zone.property[0] === "Widget7") && (
          <OnOffWidget
            health={health}
            zone={zone}
            showAll={showAll}
            setShowFreezing={setShowFreezing}
            sendWidgetCommand={sendWidgetCommand}
            isPhone={isPhone}
            show={show}
          />
        )}
        {/* {((zone.property[0] === 'Widget1' || zone.property[0] === 'Widget3' || zone.property[0] === 'Widget2') &&
                zone.property[4] === 'Conf2') && <WidgetScroll health={health} zone={zone} sendWidgetCommand={sendWidgetCommand} isPhone={isPhone} show={show} />} */}
        {(zone.property[0] === "Widget4" || zone.property[0] === "Widget5") && (
          <WidgetRadio
            health={health}
            zone={zone}
            showAll={showAll}
            setShowFreezing={setShowFreezing}
            sendWidgetCommand={sendWidgetCommand}
            isPhone={isPhone}
            show={show}
          />
        )}
      </div>
      {showFreezing && (
        <div className="w-100 h-100 position-fixed freezing  d-flex">
          <div className="freezingAnimation bg-priimary py-1 position-absolute m-auto text-center">
            <span className="d-block bg-white m-auto rounded-circle freezingCircle position-relative"></span>
          </div>
        </div>
      )}
    </>
  );
};

export { Widgets };
